<template>
   <slide-transition name="slide-fade">
      <div v-if="errors.length">
         <atom-error v-for="error in errors" :key="error" :error="error"/>
      </div>
   </slide-transition>
</template>

<script>
import AtomError from '../../../atoms/Login/Error';
import SlideTransition from '../../../atoms/Login/SlideTransition';

export default {
   name: 'error-list',
   components: {
      AtomError,
      SlideTransition
   },
   props: {
      errors: {
         type: Array,
         required: true,
      }
   }
}
</script>
